import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { ServicePlanTerm } from 'src/features/servicePlanTerms/utils/types';
import DeleteServicePlanTermFormModal from 'src/features/servicePlanTerms/components/forms/DeleteServicePlanFormTermModal';
import UpdateServicePlanTermFormModal from 'src/features/servicePlanTerms/components/forms/UpdateServicePlanTermFormModal';
import { servicePlanTermsMessages } from 'src/features/servicePlanTerms/utils/messages';

export default function CellServicePlanTermActions({ row }: CellContext<ServicePlanTerm, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateServicePlanTermFormModal
                        semantics={{ entryName: formatMessage(servicePlanTermsMessages.term).toLowerCase() }}
                        selectedServicePlanTerm={row.original}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateServicePlanTermFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeleteServicePlanTermFormModal selectedServicePlanTerm={row.original}>
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteServicePlanTermFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
